import { type ApiResponse } from '~/shared/http-client/exceptions/type'

export type ShopInfo = {
  id: number
  shop_status: string
  event_id: number
  shop: string
  buy_method: string
  ticket_type: string
  open_time: string
  ticket_usage: string
  etc: string
}

export type EventInfo = {
  id: number
  name: string
  round: number
  status: string
  place: string
  start_date: string
  end_date: string
}

export type Shop = {
  shop_info: ShopInfo
  event_info: EventInfo
}

export interface GeneralParticipationInfoApiResponse extends ApiResponse {
  data: Shop
}

export const GeneralParticipationTabs = {
  INFO: 'info',
  COSPLAYER: 'cosplayer',
  TICKET: 'ticket',
} as const

export type GeneralParticipationTab =
  (typeof GeneralParticipationTabs)[keyof typeof GeneralParticipationTabs]

export const GeneralParticipationTabLabels: {
  [key in GeneralParticipationTab]: string
} = {
  info: '일반 참가 안내',
  cosplayer: '코스프레 참가 안내',
  ticket: '티켓 구매',
}
